var _defs, _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b2bf32d8-c983-496b-ab27-aedddad6e24b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b76c220c-e217-4b74-a5f6-12c4da886715"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M729.26,91.13c183.78,34.78,92,392.78,92,392.78-7.66,78.55-90.05,84.3-90.05,84.3-586.29,70.89-608.44.69-608.44.69s-157-139.38-58.92-278.07a310.2,310.2,0,0,0,52.31-126.38c6.42-37.22,36.63-74.93,135.58-68.16a151.41,151.41,0,0,0,71.21-12.1C366.48,65.06,475.09,43,729.26,91.13Z",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M729.26,91.13c183.78,34.78,92,392.78,92,392.78-7.66,78.55-90.05,84.3-90.05,84.3-586.29,70.89-608.44.69-608.44.69s-157-139.38-58.92-278.07a310.2,310.2,0,0,0,52.31-126.38c6.42-37.22,36.63-74.93,135.58-68.16a151.41,151.41,0,0,0,71.21-12.1C366.48,65.06,475.09,43,729.26,91.13Z",
    fill: "#f26900"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M729.26,91.13c183.78,34.78,92,392.78,92,392.78-7.66,78.55-90.05,84.3-90.05,84.3-586.29,70.89-608.44.69-608.44.69s-157-139.38-58.92-278.07a310.2,310.2,0,0,0,52.31-126.38c6.42-37.22,36.63-74.93,135.58-68.16a151.41,151.41,0,0,0,71.21-12.1C366.48,65.06,475.09,43,729.26,91.13Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M777.28,507.62s11.62,24,11.77,33.79a5,5,0,0,1-2.39,4.31c-5,3.12-19.72,11.25-32,7.52L753.05,535a6.17,6.17,0,0,0,1.17,0,4.33,4.33,0,0,0,3.47-6.42,7.35,7.35,0,0,0-4.07-3.74s-4.91-5.92,5.59-6.22C759.21,518.64,766.79,518.34,777.28,507.62Z",
    fill: "#f9b499"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M754.65,553.24a41.27,41.27,0,0,0,10.28.77s-10.09-4.11-6.93-12.62a11.31,11.31,0,0,1,4.36-5.35l6.18-4.17a.9.9,0,0,0-.32-1.63c-3.1-.59-8-2.31-6.39-7.19a7.57,7.57,0,0,1,2.7-3.57,52.63,52.63,0,0,0,7.33-6.37,27.07,27.07,0,0,1-12.65,5.53s-9.75-.57-5.59,6.22a9.06,9.06,0,0,1,3.67,3.38,4.35,4.35,0,0,1-3.51,6.73l-.73,0Z",
    fill: "#f7a48b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M759.48,489.1a2.66,2.66,0,0,1-.29,1.21L746.71,515,742,512.1l12.42-24.21a2.66,2.66,0,0,1,5,1.21Z",
    fill: "#231f20",
    opacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b76c220c-e217-4b74-a5f6-12c4da886715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aefc12b4-2cd4-4012-809e-e5e9f60889fc",
    "data-name": "freepik--background-complete--inject-121"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.16,
    y: 677.4,
    width: 15.63,
    height: 0.45,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.32,563.34H67a10.26,10.26,0,0,1-10.25-10.27V64.86A10.27,10.27,0,0,1,67,54.68H414.32A10.27,10.27,0,0,1,424.59,65h0V553.07A10.27,10.27,0,0,1,414.32,563.34ZM67,55a9.81,9.81,0,0,0-9.8,9.82V553.07a9.81,9.81,0,0,0,9.8,9.82H414.32a9.84,9.84,0,0,0,9.82-9.82V64.86A9.84,9.84,0,0,0,414.32,55Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.39,563.34H456.06a10.29,10.29,0,0,1-10.27-10.27V64.86a10.29,10.29,0,0,1,10.27-10.18H803.39a10.26,10.26,0,0,1,10.23,10.18V553.07A10.26,10.26,0,0,1,803.39,563.34ZM456.06,55a9.84,9.84,0,0,0-9.82,9.82V553.07a9.84,9.84,0,0,0,9.82,9.82H803.39a9.84,9.84,0,0,0,9.82-9.82V64.86A9.84,9.84,0,0,0,803.39,55Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.92,
    cy: 105.46,
    r: 53.11,
    transform: "translate(-12.38 104.56) rotate(-13.28)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.92,
    cy: 105.46,
    r: 45.17,
    transform: "translate(-6.36 31.64) rotate(-4.06)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "440.49 127.24 440.49 105.51 426.1 113.66",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.77,138.66a2.23,2.23,0,0,1-2.25-2.2v-27.7L421,118.69a2.22,2.22,0,0,1-3-.8l0,0a2.24,2.24,0,0,1,.82-3.07h0l20.91-11.84a2.25,2.25,0,0,1,3.06.86,2.33,2.33,0,0,1,.28,1.1v31.57A2.22,2.22,0,0,1,440.77,138.66Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580.78,
    y: 134.44,
    width: 257.33,
    height: 199.97,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.59,
    y: 142.74,
    width: 241.73,
    height: 183.43,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.87,
    y: 229.2,
    width: 29.15,
    height: 41.22,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.32,
    y: 241.39,
    width: 30.7,
    height: 44.11,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.67,
    y: 172.12,
    width: 44.11,
    height: 30.7,
    transform: "matrix(0.13, -0.99, 0.99, 0.13, 438.3, 874.63)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.9,
    y: 163.69,
    width: 30.7,
    height: 44.11,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 743.2,
    y: 159.07,
    width: 30.7,
    height: 44.11,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.6,
    y: 157.76,
    width: 19.06,
    height: 19.06,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.51,
    y: 159.51,
    width: 19.06,
    height: 19.06,
    transform: "translate(255.99 710.13) rotate(-69.06)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.14,160.16a1.21,1.21,0,1,1-1.49-1.09,1.15,1.15,0,0,1,.37,0A1.11,1.11,0,0,1,619.14,160.16Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.06,160.16a1.11,1.11,0,0,1-1.09,1.15,1.12,1.12,0,1,1-.06-2.24h0A1.11,1.11,0,0,1,641.06,160.16Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.86,206.06a1.13,1.13,0,1,1-1.12-1.12h0A1.15,1.15,0,0,1,720.86,206.06Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.59,232.21a1.16,1.16,0,0,1-1.13,1.12,1.13,1.13,0,0,1,0-2.25A1.16,1.16,0,0,1,691.59,232.21Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.31,166.85a1.13,1.13,0,0,1-2.22.37,1.15,1.15,0,0,1,0-.37,1.12,1.12,0,0,1,1.29-.93A1.14,1.14,0,0,1,708.31,166.85Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 758.56,
    cy: 161.56,
    r: 1.12,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.34,165.75a1.13,1.13,0,1,1-1.12-1.12h0a1.09,1.09,0,0,1,1.12,1.06Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.21,
    y: 273.61,
    width: 61.13,
    height: 38.33,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 614.37,
    y: 268.75,
    width: 53.38,
    height: 42.13,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.57,
    y: 28.36,
    width: 206.17,
    height: 374.42,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.48,
    y: 43.17,
    width: 177.26,
    height: 345.52,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.94 43.17 38.48 370.72 38.48 193.39 78.5 43.17 125.94 43.17",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.03 43.17 72.79 388.68 55.39 388.68 147.63 43.17 165.03 43.17",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.46,
    y: 284.7,
    width: 193.79,
    height: 12.02,
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 161.18,
    y: 123.48,
    width: 473.09,
    height: 292.33,
    rx: 8.98,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.23,417.49h-453a11.72,11.72,0,0,1-11.71-11.72V133.52a11.72,11.72,0,0,1,11.71-11.71h453A11.73,11.73,0,0,1,636,133.52V405.77A11.73,11.73,0,0,1,624.23,417.49Zm-453-292.33a8.37,8.37,0,0,0-8.36,8.36V405.77a8.37,8.37,0,0,0,8.36,8.37h453a8.38,8.38,0,0,0,8.37-8.37V133.52a8.38,8.38,0,0,0-8.37-8.36Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.38,506.29c-1.78,2.27-8.87,10.57-19.17,12.35,0,0-10.06.17-5.59,6.22,0,0,4.78,2.56,3.2,17.57l-7,10.54-97.16.3s1.67-30.32-3.76-29.36l-.58,3.5a1.71,1.71,0,0,1-2.51,1.23c-3.46-1.88-11-6.81-21.95-18.55a3.22,3.22,0,0,1-.12-4.28,81.66,81.66,0,0,0,12.18-20.75s9.14-25,33-24.85h12.5l23.59-1,24.71-6.32-.06,3.88s13.2-4.5,28.84,13.64c0,0,14.61,18.26,20.1,34.67A1.34,1.34,0,0,1,778.38,506.29Z",
    fill: "#f26900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.92,415.87s-7.09,19.35.89,31.84c0,0,5.21,10.76,11.11,12.49l13.26.25S661.77,453.35,656.92,415.87Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,598.4c-83.34.78-125.39-19-135.35-23.78a6.61,6.61,0,0,1-3.76-5.72c-1.07-30.44,13.07-48.22,13.07-48.22l40.79-1,62.91-2.24,18.79-7.52s2.28,20.62,3.56,39.46Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.41,524c-7,3.74-19.75,5.43-19.75,5.43-15.18,3.36-32.74,10.39-32.74,10.39-36.88,8.61-46.33-.13-46.33-.13a63.11,63.11,0,0,1,9.07-18.78,49.33,49.33,0,0,0,12.42,5.5c9.57,2.87,24.15,4.67,43-.56,0,0,10.5-6,25.8-3.3A75.07,75.07,0,0,0,225.41,524Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.41,317.92a22.9,22.9,0,0,0-4.28,2.59l-1.86,1.42a6.24,6.24,0,0,1,3,7.38c-.05.18-.11.36-.18.55l-.06.2s2.7,4.81.6,7.83c0,0,3.31,1.5.3,8.13,0,0,2.41,6.32-8.73,8.73a57.21,57.21,0,0,1-5.16,4,1.28,1.28,0,0,0-.26.17,54.38,54.38,0,0,1-10.54,5.74l-5.13,2.9a14.48,14.48,0,0,0-3.23,2.5L333.59,388s-15.91-9-19.1-19.43l18.22-17.13s3-1.81,4.82-10.24c0,0-.9-17.16,7.82-21.67a45.83,45.83,0,0,0,11.53-12.33,12.32,12.32,0,0,0,1.6-4.54c.35-2.54,1.47-6.77,4.88-5.7a2.4,2.4,0,0,1,1.57,1.66,43.53,43.53,0,0,1,.3,18.19s32.21-14.15,33.42-9.93C398.65,306.88,401.14,311,386.41,317.92Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.49,368.57l1.74-1.62s12.32,17.76,22.61,15.57l-5.4,5.61S318.82,382.72,314.49,368.57Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.61,391.14l-10.06,18.67c-3.66,5.59-6.54,2.72-6.54,2.72.32,5-13.41,24.78-13.41,24.78l-47.4,27.91-3.9,44.69c-2.91,15.18-21.66,15.38-32.89,14.06a75.07,75.07,0,0,1-8.51-1.45c-15.3-2.71-25.8,3.3-25.8,3.3-18.87,5.23-33.46,3.43-43,.55a49.44,49.44,0,0,1-12.42-5.49l-.66-.46c-5.26-3.8,4-10.18,4.47-10.5h0c-3.83-.51-7.46-.84-9.83-1a12.89,12.89,0,0,0-4.74.55c-4.72,1.45-5.7-.69-5.78-2.52a2.85,2.85,0,0,0-2.34-2.62l-.4-.09h-.12c-8.36-.32-16.69-5.09-16.69-5.09-3.94-1.66-6.2-6.19-7.36-12,0-.2-.09-.41-.13-.62-3.18-17.3,2.7-45.25,2.7-45.25a680.08,680.08,0,0,1,18.57-92.14c6-21.82,21.69-39.39,43.37-45.9A57.94,57.94,0,0,1,167,301.12a5.94,5.94,0,0,1,4.8,1.72l7.5,4.15,30.83,4.64,8.77-7.95c23.46,2.59,29.65,16.62,29.65,16.62,8.58,13.91,10.79,31.78,11.35,39.86a54.57,54.57,0,0,0,1.52,9.22,169.67,169.67,0,0,1,4.27,28.94c1,5.75,6.38,2.4,6.38,2.4l34-28.91c2.84-2.91,4.94-3.94,6.27-4.27a1.85,1.85,0,0,1,2.14,1C319.69,380.87,339.61,391.14,339.61,391.14Z",
    fill: "#f26900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.81,302.84s25.12,26.68,41.6,30.43c0,0,5.9-3.71,5.87-10.86l-.38-18.73-1.46,0a.8.8,0,0,1-.78-.71l-1.26-11.75-7.86-4.74-28.83-10.73,0,1.42v16.12S179.89,297.14,171.81,302.84Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.32,176.55s-4.39,6.53-14.36,13.86c0,0,9.86-8.21,7.42-13.3A30.59,30.59,0,0,1,188.32,176.55Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,462.18s-25.94,20.94-27.76,42c-8.36-.32-16.69-5.09-16.69-5.09-3.94-1.66-6.2-6.19-7.36-12,3.46,3,14.86,11.15,23.67-3.6C115.9,483.48,126.68,464.28,144,462.18Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.94,460.86a48.55,48.55,0,0,1-3.83-14.07,58.87,58.87,0,0,1,0-14.65A55.37,55.37,0,0,1,147.07,418c.93-2.29,2.1-4.36,2.83-6.67a42.18,42.18,0,0,0,1.77-7,36.07,36.07,0,0,1-1.25,7.2c-.63,2.37-1.76,4.6-2.56,6.84a58.46,58.46,0,0,0-3.59,13.94A62.57,62.57,0,0,0,144,446.7c.09,1.2.27,2.39.41,3.59s.38,2.39.66,3.57A47.71,47.71,0,0,0,146.94,460.86Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.59,215.21a11.12,11.12,0,0,1-1.83-3.31c-3-7.86-7.87-8.61-7.87-8.61a6.8,6.8,0,0,0,.15-3.89S205,201.24,206.59,215.21Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.15,329.35l8.1,10.7a.73.73,0,0,0,1.28-.22c1.08-3.53,3.63-13.46,1.32-22.46l-4.79-13.09-4.16-.6.38,18.73A11.57,11.57,0,0,1,217.15,329.35Z",
    fill: "#f26900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.15,329.35l8.1,10.7a.73.73,0,0,0,1.28-.22c1.08-3.53,3.63-13.46,1.32-22.46l-4.79-13.09-4.16-.6.38,18.73A11.57,11.57,0,0,1,217.15,329.35Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.89,300.93s24.45,27,43.52,32.34c0,0,1.51-1.21-4.56,12.84,0,0-37.36-13.89-44.39-44.55A35.23,35.23,0,0,1,169.89,300.93Z",
    fill: "#f26900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.89,300.93s24.45,27,43.52,32.34c0,0,1.51-1.21-4.56,12.84,0,0-37.36-13.89-44.39-44.55A35.23,35.23,0,0,1,169.89,300.93Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,504.67s-13.15,16-41,9.21c0,0-22.36-3.16-29.72,1.58a59.22,59.22,0,0,0-17.21,10.92c-8.54-2.56-13.08-6-13.08-6-5.26-3.8,4-10.18,4.47-10.5h0a115.15,115.15,0,0,1,17.11,5.55s1-7.37,2.37-10l50.22,4.47S226.83,511,236,504.67Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,411.57a43.57,43.57,0,0,1-.48,9.13c-3.14,19,1.25,32.16,1.25,32.16C169.49,478.9,210,481,210,481c-23.94,1.05-40.24-7.1-40.24-7.1l-6-2.89a37.51,37.51,0,0,0-16.05-10c-10.52-23.4,1.85-37.87,1.85-37.87.54-1,1-2.07,1.44-3.05a25.37,25.37,0,0,0,1.88-10.41c-.15-10.35,6.14-20.2,6.14-20.2Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.09,390.27s-12.88,39.45-34.71,56.54C187.38,446.81,221.3,442.6,222.09,390.27Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,395.26s2.1,41.29-10.26,62.07a16.54,16.54,0,0,1,.53,4.74l19.2-18.68,10.26-2.1s-14.47-8.15-5.79-37.87C270,403.42,258.91,406.57,256,395.26Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.89,395.79s16.59,21,13.71,32.06c0,0,5.54-7.86,7.42-15.32Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.18,524.38s22.38,1.64,25.12-14.47C258.3,509.91,260.61,533,233.18,524.38Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4,497.06l-56.73.8-5.89-15.79,5.89-2.67L244.78,466a5.75,5.75,0,0,0,1.51-3.95l19.2-18.68s55.82,4.7,73.48,3.09C339,446.48,313.55,474.58,288.4,497.06Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.49,443.39l64.65-11.09L320,446.71S287.53,445.65,265.49,443.39Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,358.33l1,.44a1.28,1.28,0,0,0-.26.17,33.77,33.77,0,0,1-10.65-6.16,24.57,24.57,0,0,1-4.93-5.89,23.29,23.29,0,0,1-1.69-3.48,19.17,19.17,0,0,1-.59-1.86,13.38,13.38,0,0,1-.29-2,10.37,10.37,0,0,1,2.5-7.35,18.69,18.69,0,0,1,6.15-4.65,43.85,43.85,0,0,1,14.61-4,58.54,58.54,0,0,0-7.31,1.9,39.91,39.91,0,0,0-6.91,2.9,19.31,19.31,0,0,0-5.75,4.53,9.82,9.82,0,0,0-1.75,3.12,10,10,0,0,0-.43,3.52,12.71,12.71,0,0,0,.26,1.78,14,14,0,0,0,.52,1.75,20.6,20.6,0,0,0,1.56,3.33,26.32,26.32,0,0,0,4.63,5.78c.44.44.94.82,1.4,1.23l.71.61.76.54c.52.36,1,.74,1.54,1.08l1.6,1a14.62,14.62,0,0,0,1.65.9Z",
    fill: "#f8a58b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.23,329.31c-.05.18-.11.36-.18.55-1.28.64-2.58,1.27-3.87,1.88-2.16,1-4.36,2-6.55,3s-4.42,1.87-6.67,2.72l-3.36,1.28c-1.14.39-2.26.81-3.41,1.17,1.05-.59,2.14-1.12,3.2-1.68l3.24-1.56c2.16-1,4.36-2,6.55-2.95s4.41-1.87,6.66-2.73C380.29,330.39,381.76,329.83,383.23,329.31Z",
    fill: "#f8a58b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.93,338.69a56.47,56.47,0,0,1-8.31,4.49c-1.44.63-2.9,1.23-4.39,1.74a25,25,0,0,1-4.6,1.18c1.45-.64,2.85-1.34,4.27-2s2.84-1.31,4.27-1.95C376,340.9,378.92,339.67,381.93,338.69Z",
    fill: "#f8a58b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.27,346.1a35.57,35.57,0,0,1-5.78,3.2,34,34,0,0,1-6.25,2.18,34.13,34.13,0,0,1,5.79-3.2A35,35,0,0,1,381.27,346.1Z",
    fill: "#f8a58b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.9,312s-5.93,7.42-10.15,9.77a49.51,49.51,0,0,0,9.47-4.91S365.66,314.6,365.9,312Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 691.16,
    cy: 415.28,
    rx: 34.35,
    ry: 47.43,
    transform: "translate(-25.44 45.62) rotate(-3.71)",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.05,407.11c7.76,4.34,11.1,20.13,11.1,20.13,5.21-4.17,1.74-14.58,1.74-14.58l5.71,16.53c-6.78,25.55-19.59,30-19.59,30l.69,2.09,9-1.74c4.86-2.43,14.92-2.78,14.92-2.78,20.82-9.37,16.31-50.66,16.31-50.66-4.51-30.88-21.51-42-21.51-42-23.94-18.74-39.21-4.16-39.21-4.16-17.7-14.23-30.89,16.31-30.89,16.31-8.28,20.72-2.94,32-.41,35.71a1.59,1.59,0,0,0,2.38.31l1.72-1.48a6.94,6.94,0,0,1,4.57-1.72c14.92.07,20.89-23.8,20.89-23.8S694.25,400.52,706.05,407.11Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.41,460.2s1.53,2.91-.31,9.37a10.23,10.23,0,0,1-.42,1.09c-.57,1.27-1.47,5.43,8.11,9.42,0,0,11.74,7.67,22.28-3.35,0,0,13.41-10.3,4.79-18l-10.16,2.48-.69-2.09S695.82,466.19,681.41,460.2Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.41,460.2s1.47,2.91-.26,9.26c0,0,17.56.88,23.86-10.3C705,459.16,695.34,466.67,681.41,460.2Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.81,518.48s-3.46,22.28-.71,34.79h-4.47s1.67-30.32-3.76-29.36l7.24-16.19a1,1,0,0,1,1.78,0C658.57,509.55,659.13,512.86,657.81,518.48Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.75,544.57c0,7.67-4.6,4.35-4.6,4.35,0,5.36-4.86,2.3-4.86,2.3-1.79,5.88-7.17.5-7.17.5-.76,4.86-6.39.52-6.39.52-7.42,3.07-6.39-7.67-6.39-7.67s0,0,0-.06a26.2,26.2,0,0,1-.47-6.72c.79-14.58,12.76-26,12.76-26,10.56,11.53,18.78,16.08,18.78,16.08-1.36,1.75-2,5.05-2.28,6.64a1.86,1.86,0,0,0,.36,1.46C649.6,545.3,642.75,544.57,642.75,544.57Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620,545.33a18.17,18.17,0,0,1,3.43,2.85,17.92,17.92,0,0,1,2.71,3.55,19.83,19.83,0,0,1-6.14-6.4Z",
    fill: "#f8a58b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.29,551.22a42.59,42.59,0,0,1-5-4.79,41.75,41.75,0,0,1-4.23-5.45,47.72,47.72,0,0,1,9.21,10.24Z",
    fill: "#f8a58b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.15,548.91a48.14,48.14,0,0,1-6.91-12,48.14,48.14,0,0,1,6.91,12Z",
    fill: "#f8a58b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.75,544.56a28.73,28.73,0,0,1-4.86-9.46,25.24,25.24,0,0,1,2.88,4.5A26.06,26.06,0,0,1,642.75,544.56Z",
    fill: "#f8a58b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627,533.18c-3.77,1.8-11.08,6.7-13.62,11.33a26.2,26.2,0,0,1-.47-6.72A24.26,24.26,0,0,1,626.63,532,.64.64,0,0,1,627,533.18Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.27,538.91s-5.62-10.18,3.39-9.5l9.7-.27Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.37,553.27s-3.44-.94-4.4-10.2c0,0,47.26,10.54,65.78,7.35l.32,2.87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.2,538s-1.92,6.71,1.59,10.54c0,0,31.94,4.47,39,1.92l.32,2.87a80.65,80.65,0,0,0,11.18-2.55l-7.35-9S700,560,687.2,538Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.2,565.23l-587.95,0a6,6,0,0,1-6-6h0a6,6,0,0,1,6-6l588,0Z",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "728.27 538.91 725.64 550.51 733.73 541.23 728.27 538.91",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.71,275.72l-.05,12.36s19.13,12.39,31.14,3.53Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.08,241.11c0,18.67-6.72,35.05-16.85,44.34h0a32.07,32.07,0,0,1-8.83,5.85,25.85,25.85,0,0,1-10.46,2.23c-20,0-36.14-23.47-36.14-52.43s16.18-52.43,36.14-52.43S241.08,212.16,241.08,241.11Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.93,294.86c5,16.16.62,25.44.62,25.44-7.8-14.28-27.26-16.36-31.14-16.63a.76.76,0,0,1-.74-.7l-1.28-11.79c31.14-15.64,25.07-59.71,25.07-59.71a23.34,23.34,0,0,0-7-9.24,18.92,18.92,0,0,0-13.57-3.46c-.51.06-1,.14-1.54.23-6.35,1.17-9.92-1.42-11.81-3.79a11,11,0,0,1-1.84-3.31c-3-7.86-7.86-8.61-7.86-8.61A37.13,37.13,0,0,1,183.34,230a8.48,8.48,0,0,0-3.11,5.57c-1,8.78-5.44,11.17-5.44,11.17l-3.47,13c2.93,11,7.35,17.41,7.35,17.41v16.12c.74,4.88-6.87,9.58-6.87,9.58a4.45,4.45,0,0,1-1.91-1.92c-13.22.85-23.94,6.35-31.09,11.33a60,60,0,0,0-9.73,8.24,18.86,18.86,0,0,0,3.44-11.65,27.8,27.8,0,0,0-4.42-14.31c-3.77-6-5.25-11.48-5.29-16.33-.18-15.85,14.84-25.17,14.84-25.17a26.75,26.75,0,0,0,12.45-28.75c-4.78-14.68.32-23.63.32-23.63,12.45-24.91,38.64-24,38.64-24a10.07,10.07,0,0,1,5.11-4.79,11.65,11.65,0,0,1,5.54-.86C230.92,173.5,243,194.59,243,194.59c23.64,35.76,3.16,71.72,3.16,71.72C241.92,275,247.93,294.86,247.93,294.86Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.46,259.7c-5.37,1.88-11.87-2.76-14.53-10.36-2.49-7.14-.69-14.35,4-16.74a5.25,5.25,0,0,1,.94-.41,8,8,0,0,1,5.38.1c3.78,1.33,7.35,5.11,9.15,10.26C179,250.15,176.82,257.83,171.46,259.7Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8,312.25a60,60,0,0,0-9.73,8.24,18.86,18.86,0,0,0,3.44-11.65,27.8,27.8,0,0,0-4.42-14.31c-3.77-6-5.25-11.48-5.29-16.33.24.89,3.77,12.91,10.14,18.94a19.59,19.59,0,0,1,5,7.12A15.34,15.34,0,0,1,138.8,312.25Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,257.2s5.16,9.15-.19,14.25c0,0-8.1,6.66-4.31,21.81,0,0,2.09,5.22,1.17,9.4,0,0,7.81-1.77,11.22-1.73a4.85,4.85,0,0,0,1.92,1.91s7.44-4.66,6.86-9.58V277.14a64.38,64.38,0,0,1-7.34-17.4S166.88,261.46,162,257.2Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,232.29a8,8,0,0,0-5.38-.1,5.25,5.25,0,0,0-.94.41,17.34,17.34,0,0,0,3.75-9.3s1.48-14.48,6-19.88C170.68,203.42,166.08,221.59,167.23,232.29Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.46,231.47a23.41,23.41,0,0,0-7-9.24,18.92,18.92,0,0,0-13.57-3.46l-.07-.11s3.92-4.54,11.28-1.46C231.15,217.2,237,219.86,240.46,231.47Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87,306c-.52-.12-8.68-2.12-11-2.36,0,0-1.73.27-2.23-.74l-1.27-11.63a32.07,32.07,0,0,0,8.83-5.85C224.5,290.44,225.59,302.21,229.87,306Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.8,476.45s-13.91,14.18-26.75,16.33c0,0-7,2.67-16.06,6.43,0,0-7.6,4.51-12,5.46,0,0-4.34,5.3-26.83,5.26l-28.26-2.51-22-2a172.56,172.56,0,0,1,10.78-31.56,38.38,38.38,0,0,0,5.79,2.38c6,2,16.72,4.64,32.25,4.72a4.58,4.58,0,0,0,3.52-1.58c3.1-3.6,11.11-12.28,18.47-15,0,0,9.09-5.32,13.55-8.69a1.17,1.17,0,0,1,1.8.52c1,2.46,2.39,7.42-.36,9.78L231.67,479.4s-1.34,1.6,1.07,2.4c0,0,9.64.27,16.32-4.81,0,0,17.39-15.79,21.94-13.92,0,0,3.22,1.07,0,4.82,0,0-15.78,12.85-15.78,18.19l13.38-8.83s20.61-13.91,18.46-3.2C287.06,474.05,294.55,471.9,290.8,476.45Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.06,
    y1: 474.05,
    x2: 267.79,
    y2: 487.16,
    fill: "none",
    stroke: "#f8a58b",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.63,507.08l-.42.19L159,505.46a172.56,172.56,0,0,1,10.78-31.56L175,476l-.19.09c-1.44.7-10.81,5.86-7.83,19.7C167,495.83,168.85,502,180.63,507.08Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.6,389.74c.13,1.89.19,3.77.29,5.66l.19,5.65c.13,3.77.18,7.54.25,11.3s.1,7.54.1,11.31v5.66c0,1.88,0,3.77-.05,5.66-.41-3.76-.63-7.53-.82-11.3s-.28-7.54-.35-11.31-.07-7.54,0-11.31S257.37,393.51,257.6,389.74Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.49,407.89c-.51,4.11-1.24,8.19-2,12.26s-1.7,8.11-2.72,12.13-2.13,8-3.48,12a88.44,88.44,0,0,1-4.67,11.52c.34-1,.69-1.95,1.05-2.92s.65-2,1-2.94c.65-2,1.25-3.94,1.82-5.92,1.15-4,2.2-8,3.22-12s2-8,3-12Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 727,
    cy: 417.16,
    rx: 12.27,
    ry: 8.58,
    transform: "translate(175.63 1048.45) rotate(-78.71)",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.07,179.14a.57.57,0,0,1-.55-.46A.56.56,0,0,1,311,178l25.22-4.47a.56.56,0,0,1,.2,1.1l-25.23,4.47Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.2,211.19c-.42,0-.84,0-1.26-.07-4.46-.48-8.16-3.57-11-9.19a33.69,33.69,0,0,1-3.44-15.61c0-2.77.22-5.6.52-8.44a.56.56,0,0,1,1.11.12c-.3,2.8-.47,5.61-.51,8.34A32.53,32.53,0,0,0,318,201.43c2.64,5.25,6.05,8.14,10.11,8.58,9.54,1,19.84-11.54,19.94-11.66a.56.56,0,1,1,.87.7C348.45,199.56,338.92,211.19,329.2,211.19Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.58,194.79a.57.57,0,0,1-.55-.48.58.58,0,0,1,.47-.64l16.61-2.55a.56.56,0,0,1,.17,1.1l-16.61,2.56Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.64,184.57a.56.56,0,0,1-.12-1.11l24.59-5.11a.56.56,0,0,1,.23,1.1l-24.59,5.1Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.23,194.15a.58.58,0,0,1-.54-.41.57.57,0,0,1,.4-.69l22-6.07a.56.56,0,0,1,.3,1.08l-22,6.07Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.11,204.37a.56.56,0,0,1-.47-.26c-5.13-8-7-29.06-7.11-30a.56.56,0,0,1,.5-.61.57.57,0,0,1,.61.51c0,.2,1.64,18.12,5.72,27.15-.61-8.81-1.41-27.15,2.24-27.87,1.52-.31,3.91,1.49,9.18,17.77.23-6.62,1.12-14.14,4-14.94,1.37-.39,2.87.71,4.58,3.36a25.81,25.81,0,0,1,2.56,5.3,52.2,52.2,0,0,1,3,12.86.56.56,0,1,1-1.11.1,51.68,51.68,0,0,0-3-12.59,25.11,25.11,0,0,0-2.45-5.07c-1.35-2.09-2.54-3.11-3.34-2.89-1.76.5-3,6.25-3.18,15a.93.93,0,0,1-1.81.25c-5.49-17.18-7.71-18.17-8.24-18.06-2.11.41-2.24,15.54-1.16,29.32a.55.55,0,0,1-.37.58A.57.57,0,0,1,409.11,204.37Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,200.63a4.71,4.71,0,0,1-.53,0c-6-.54-9.32-10.25-9.46-10.67-3.53-11.11,1-16.86,3.12-18.81a4.83,4.83,0,0,1,3.21-1.35A3.15,3.15,0,0,1,453,171c1.66,2.18.42,6.63.36,6.81a.56.56,0,1,1-1.07-.3c.32-1.14.92-4.39-.18-5.83a2.07,2.07,0,0,0-1.78-.75,3.67,3.67,0,0,0-2.46,1.05c-2,1.81-6.15,7.15-2.81,17.65,0,.08,3.21,9.42,8.49,9.9,3.37.32,6.91-3,10.6-9.68a.56.56,0,1,1,1,.53C461.41,197.17,457.66,200.63,454,200.63Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.6,175.31a.57.57,0,0,1-.53-.72,91.57,91.57,0,0,0,3.69-17.42,5.18,5.18,0,0,0-1-3.69c-.57-.73-1.11-1-1.59-.95-1.23.23-2.43,2.88-2.9,4.49a.56.56,0,0,1-1.08-.31c.15-.49,1.47-4.84,3.76-5.28a2.78,2.78,0,0,1,2.69,1.36,6.32,6.32,0,0,1,1.24,4.48,91.12,91.12,0,0,1-3.45,16.65l19.77-5.78a.56.56,0,1,1,.32,1.08l-20.76,6.06A.41.41,0,0,1,458.6,175.31Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.76,356.67a7.9,7.9,0,0,1-7.9-8.66c.68-7.15,4.35-19.84,17.94-39.68.6-.82,59.72-80.26,102.2-79.47a13.2,13.2,0,0,1,12.62,15.91c-1.5,7-5.34,15.28-11.43,24.72-.62.88-61.48,86.08-113.26,87.18h-.17ZM560.38,230c-41.86,0-100.09,78.22-100.67,79C446.26,328.6,442.64,341.1,442,348.12a6.68,6.68,0,0,0,1.77,5.26,6.79,6.79,0,0,0,5.15,2.17h0c51.23-1.09,111.76-85.83,112.37-86.68,6-9.32,9.79-17.51,11.26-24.34A12.1,12.1,0,0,0,561,230Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.77,368.61c-3.43,0-9.92-6.19-19.33-18.44-10.1-13.16-22.07-31.5-33.69-51.64-21.52-37.27-39.88-78-33.37-81.82,6.77-3.89,33,33,54.18,69.8,11.62,20.14,21.52,39.68,27.87,55,6.65,16.06,8.5,25.08,5.49,26.81A2.21,2.21,0,0,1,551.77,368.61Zm-85.12-151.1a1.49,1.49,0,0,0-.71.17c-4.55,2.63,7.93,35.52,33.77,80.29,11.61,20.1,23.55,38.39,33.62,51.52,11.31,14.74,17.25,18.89,19,17.87s1.15-8.25-6-25.42c-6.33-15.28-16.21-34.77-27.81-54.87C493.89,244.29,472.48,217.51,466.65,217.51Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,300.62c-4.39,0-8.52-.05-12.36-.15-25.57-.67-25.72-3.19-25.77-4.14s-.2-3.46,25.13-7.05c16-2.26,37.37-4.23,60.12-5.53s44.2-1.78,60.37-1.36c25.57.68,25.71,3.19,25.76,4.14.33,5.64-50.8,10.62-85.25,12.59C488.63,300.11,472.05,300.62,458,300.62Zm95.12-17.26c-14,0-30.6.51-47.93,1.5-22.73,1.3-44.05,3.27-60,5.53-24,3.4-24.17,5.78-24.16,5.88s.41,2.45,24.68,3.08c16.13.43,37.54-.05,60.27-1.35,52.4-3,84.35-8.66,84.2-11.41,0-.09-.42-2.44-24.68-3.08C561.61,283.41,557.48,283.36,553.1,283.36Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.4,
    cy: 242.78,
    r: 9.86,
    fill: "#f26900"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.4,
    cy: 242.78,
    r: 9.86,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.77,
    cy: 292.42,
    r: 9.86,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.21,
    cy: 351.61,
    r: 9.86,
    fill: "#f26900"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.94,
    cy: 292.42,
    r: 16.87,
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.48,489.1a2.66,2.66,0,0,1-.29,1.21L746.71,515l-8.49,16.79-10,7.16L742,512.1l12.42-24.21a2.66,2.66,0,0,1,5,1.21Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.23,545.94a4.59,4.59,0,0,1-3.28-2.33,3.92,3.92,0,0,1,1.32-4.7l13.92-10.54a5.86,5.86,0,0,1,4.7-1.14,3.78,3.78,0,0,1,3.19,4.11,5.14,5.14,0,0,1,4.11,5.93s4.11,5.25.91,8.44c0,0,2.74,8.45-3.88,8.9,0,0-9.12,2.74-9.35-1.59,0,0-8.21,3.65-8-1.83C733.88,551.19,729.32,551.42,730.23,545.94Z",
    fill: "#f9b499"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a4018c06-9df1-4669-9e88-e5602fb940da",
    "data-name": "freepik--Plant--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.45,514.26s8.4-30.18,15.1-40.42,19.25-21.52,19.25-21.52S546.55,498.88,512.45,514.26Z",
    fill: "#f26900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513,513.78a142.35,142.35,0,0,0,7.67-14.63,101.54,101.54,0,0,1,4.18-15.89c0-.1.17,0,.14.06-1.11,4.77-2.41,9.5-3.58,14.25,3.35-7.34,6.61-14.79,10.66-21.74a46.12,46.12,0,0,1,3.9-9.65c0-.09.19,0,.15,0a60.28,60.28,0,0,0-2.62,7.25,71.82,71.82,0,0,1,6.39-8.83c.15-.18.44,0,.29.2-5.37,7-9.11,14.81-12.65,22.76a119.5,119.5,0,0,0,10.56-13.2s.1,0,.07.05a108.34,108.34,0,0,1-11.3,14.66c-2.59,5.82-5.14,11.66-8.22,17.21,6.16-5.21,10.91-12,15.64-18.47a.15.15,0,0,1,.21,0,.16.16,0,0,1,0,.15c-4.71,7.14-9.57,13.87-16.33,19.16a76.15,76.15,0,0,1-4.47,7,.41.41,0,0,1-.56.16A.42.42,0,0,1,513,513.78Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.85,517s15.12-27.85,10.73-54.85-9.1-36.61-9.1-36.61S487.71,467.55,509.85,517Z",
    fill: "#f26900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.63,473.24a132.31,132.31,0,0,0,5.85,22.49c0-9.92.22-19.82.49-29.73a76.27,76.27,0,0,1-2.85-18.44.14.14,0,0,1,.28,0,104.22,104.22,0,0,0,2.65,15.88c.22-8.18.5-16.35.79-24.52a.13.13,0,0,1,.14-.08.16.16,0,0,1,.08.08c0,12.76,0,25.52-.08,38.3A104,104,0,0,0,515.34,462h.09A59.71,59.71,0,0,1,511,479.3c0,8.16-.14,16.32-.32,24.47,2.56-8.67,5.29-17.07,6-26.24,0-.12.21-.12.19,0-.19,10.12-2.8,20.38-6.13,29.89a.48.48,0,0,1-.17.23c-.08,3-.16,6-.26,8.94a.34.34,0,1,1-.67,0q-.17-9.15-.14-18.3a82.08,82.08,0,0,1-6-25.07S503.62,473.16,503.63,473.24Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.67,468.94a50.62,50.62,0,0,1,1.05,7.35.07.07,0,0,1-.13,0,52,52,0,0,1-1.25-7.33C504.32,468.78,504.64,468.75,504.67,468.94Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.51,448.58c0-.09.15-.06.15,0a19,19,0,0,1-.76,5.08c0,.13-.24.07-.2-.07C513,451.94,513.23,450.26,513.51,448.58Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.33,519.14s.61-29.06-7.73-43.51a62.45,62.45,0,0,0-22.16-21.8S480,505.06,504.33,519.14Z",
    fill: "#f26900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.14,494.29a107.88,107.88,0,0,0,11.27,14.3q-2.49-8.94-5.76-17.52c-4.67-4.11-9.31-8.35-12.18-14,0-.09.08-.17.13-.08,3.08,5,7.21,8.94,11.54,12.76a223.58,223.58,0,0,0-11.6-25.28.18.18,0,0,1,.07-.25.2.2,0,0,1,.25.07,140,140,0,0,1,7.28,13.27c-.78-3.11-1.4-6.29-2.23-9.37a.07.07,0,0,1,.07-.06.06.06,0,0,1,.06.06,52.65,52.65,0,0,1,3.42,12.3,147.72,147.72,0,0,1,7.35,19.89c-.22-4.36-.5-8.69-.94-13a.07.07,0,0,1,.14,0A69.14,69.14,0,0,1,499.27,502q1.82,6.51,3,13.13c0,.12-.15.17-.18.06-.45-1.86-.95-3.69-1.45-5.52h-.09a58.53,58.53,0,0,1-11.51-15.29S489.12,494.26,489.14,494.29Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.49,470.67c.93,1,1.79,2.06,2.68,3.09a23.83,23.83,0,0,1,2.41,2.81s0,.09-.07.07a15,15,0,0,1-2.77-2.74,22.64,22.64,0,0,1-2.38-3.13.08.08,0,0,1,.06-.11A.06.06,0,0,1,479.49,470.67Z",
    fill: "#2100a3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.11,515.6l-1.06,9.32-3.17,28.17H497.26l-3.17-28.17-1-9.32Z",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.11,515.6l-1.06,9.32h-34l-1-9.32Z",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.59,
    y: 508.85,
    width: 40.96,
    height: 10.55,
    fill: "#dbdbdb"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M754.21,535s-.46-2.71-4.13-3.68c0,0-1.84-7.42-8.63-2.52.14-.39,3.4-9.11.73-15.12,0,0-5.47-8.46-2.6-16,0,0,9.49,25.06,14,27.15,0,0,1.11.32,2.39,3.52C756,528.39,758.3,534,754.21,535Z",
    fill: "#231f20",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M730.23,545.94a54.15,54.15,0,0,1,11.87-8.67,54.15,54.15,0,0,1-11.87,8.67Z",
    fill: "#f8a58b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M733.89,551.19a54,54,0,0,1,6.47-4.42,53.37,53.37,0,0,1,7-3.56,61.78,61.78,0,0,1-13.46,8Z",
    fill: "#f8a58b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M741.87,553a16.37,16.37,0,0,1,3.67-2.28,15.89,15.89,0,0,1,4.09-1.37,18.93,18.93,0,0,1-7.76,3.65Z",
    fill: "#f8a58b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/Teacher.57ac21ed8dc6a89f7635ac215687ae53.svg";
export { ForwardRef as ReactComponent };